<script lang="ts">
    import { serializeSchema } from "$lib/json-ld"
    import { toHTML } from '@portabletext/to-html'
    import type { BreadcrumbList } from "schema-dts"
    import type { FAQSchema, BreadcrumbSchema, ProductSchema, FAQMainEntityItem } from '../../types/index'
    export let accordionContent
    export let name : string
    export let slug : string
    export let reviewRating : {
        name: string
        description: string
        value: number | string | null
        total: number
    } = {
        name: '',
        description: '',
        value: null,
        total: 16
    }
    export let userReviews = []

    let hasAccordion = accordionContent.filter(item => {
        if(item.accordion) return item
    })

    let schemaFAQAccordionItems : FAQMainEntityItem[] = []

    let faqSchema : FAQSchema  = {
        "@type": "FAQPage",
        "mainEntity": schemaFAQAccordionItems
    }

    let breadcrumbList : BreadcrumbList[] = [
        {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.offerzen.com/"
        },
        {
            "@type": "ListItem",
            "position": 2,
            "name": "Hire developers",
            "item": "https://www.offerzen.com/hire-developers/"
        },
        {
            "@type": "ListItem",
            "position": 3,
            "name": `${name}`,
            "item": `https://www.offerzen.com/hire-developers/${slug}`
        },
    ]

    let breadcrumbSchema : BreadcrumbSchema = {
      "@type": "BreadcrumbList",
      "itemListElement" : breadcrumbList
    }

    let productSchema : ProductSchema

    if(reviewRating.value) {
        productSchema = {
            "@type": "Product",
            "aggregateRating": {
                "@type":"AggregateRating",
                "ratingValue": reviewRating.value,
                "reviewCount": reviewRating.total
            },
            "name": reviewRating.name,
            "description": reviewRating.description,
            "brand": "OfferZen"
        }

        if (userReviews) {
            let reviews = userReviews.map(review => {
                return {
                    "@type": "Review",
                    "author": {
                        "@type" : 'Person',
                        "name" : review.author
                    },
                    "description" : review.content,
                    "name" : review.heading,
                    "reviewRating" : {
                        "@type" : "Rating",
                        "ratingValue" : review.rating
                    }
                }
            })

            productSchema = {...productSchema, "review" : reviews}
        }
    }

    let schemaItems : BreadcrumbSchema[] | ProductSchema | FAQSchema = [
        breadcrumbSchema
    ]

    if(hasAccordion.length && hasAccordion[0]?.enable_schema) {
        accordionContent[0].accordion.forEach((item) => {
            if(item.add_to_faq_schema) {
                return  schemaFAQAccordionItems.push({
                    "@type": "Question",
                    "name": item.heading,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": toHTML(item.accordion_item[0].paragraph)
                    }
                })
            }
        })

        schemaItems.push(faqSchema)
    }

    if(reviewRating.value) {
        schemaItems.push(productSchema)
    }

    let schema = {
        "@context": "https://schema.org",
        "@graph" : schemaItems
    }
</script>

{@html serializeSchema(schema)}
